export enum DlmMode {
  Deaktiviert = 0,
  DLMMasterWithInternalSlave = 1,
  Standalone = 2,
  MasterAutoDiscovery = 3,
  MasterFixedIP = 4
}
